/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconSocialSystemReaction = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M11.944 7.27A.5.5 0 0 0 11.5 7H8.773L10.572.668a.5.5 0 0 0-.89-.424L4.09 8.213A.5.5 0 0 0 4.5 9h2.727L5.43 15.332a.5.5 0 0 0 .89.424l5.59-7.969a.5.5 0 0 0 .035-.517z"
    />
  </svg>
);

IconSocialSystemReaction.displayName = 'IconSocialSystemReaction';

IconSocialSystemReaction.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconSocialSystemReaction);
IconSocialSystemReaction.displayName = 'IconSocialSystemReaction';
